import template from './statistic.html';
import './statistic.scss';

const component = {
	bindings: {
		decimals: '@',
		icon: '@',
		outlet: '<',
		title: '@',
		total: '<',
		currency: '@',
		percentage: '@',
		user: '<'
	},
	template,
	controller: function(
		$scope
	) {
		"ngInject"

		var vm = this;
		var interval;
		
		function init() {
			vm.percent = 0;
			vm.average = 0;

			if (!vm.decimals) vm.decimals = 0;
			if (!vm.total) vm.total = 1;

			if (vm.outlet > 0) {
				vm.average = vm.outlet / vm.total;
				if (vm.user) {
					vm.percent = Math.abs(((vm.user - vm.average) / vm.average) * 100);
				}
				
			}

			vm.direction = vm.user >= vm.average;
		}

		this.$onChanges = (obj) => {
			init();
		}

		

		init();
		
	}
};

export default component;



// WEBPACK FOOTER //
// ./app/components/statistic/statistic.component.js